'use client';

/**
 * @packageDocumentation
 * @category Component
 */

import { Combobox } from 'BomdisoftComponents/inputs/combobox/index';
import { BulkActionSelectOption } from 'BomdisoftComponents/types';
import { useState } from 'react';

type BulkActionSelectProps = {
  options: BulkActionSelectOption[];
  selected: BulkActionSelectOption | null;
  selectHandler: (newSelectedItem: BulkActionSelectOption | null) => void;
  placeholder: string;
  noOptionsText: string;
};

export const BulkActionSelect = ({ options, selected, selectHandler, placeholder, noOptionsText }: BulkActionSelectProps) => {
  const [inputValue, setInputValue] = useState(selected?.name ?? '');
  const [previousSelected, setPreviousSelected] = useState(selected);
  if (selected !== previousSelected) {
    setPreviousSelected(selected);
    setInputValue(selected?.name ?? '');
  }

  const isFiltering = inputValue !== '' && inputValue !== selected?.name;
  const visibleOptions = isFiltering ? options.filter(option => option.name.toLowerCase().includes(inputValue.toLowerCase())) : options;

  const handleSelect = (option: BulkActionSelectOption | null) => {
    selectHandler(option);
    setInputValue(option?.name ?? '');
  };

  return (
    <Combobox
      clearable
      getOptionKey={option => String(option.id)}
      getOptionLabel={option => option.name}
      inputValue={inputValue}
      isOptionSelected={option => option.id === selected?.id}
      noOptionsText={noOptionsText}
      onInputChange={setInputValue}
      onSelect={handleSelect}
      options={visibleOptions}
      placeholder={placeholder}
      testId='select-bulk-action-value'
    />
  );
};
